export default __webpack_public_path__ + "static/media/1.80591a25.png";